<template>
	<div class="special-product-message-box wrapper-with-border">
		<div class="wrapper">
			<div :class="['content', 'grey-darkgrey']">
				<div class="main-button">
					<ui-button
						v-if="showSpecialStockMessage"
						:color="buttonColor"
						size="full"
						:disabled="true"
						@click="buttonClicked"
					>
						{{ buttonText }}
					</ui-button>
				</div>
				<div class="secondary-text">
					{{ message }}
					<a v-if="isInStore" class="link-to-store-finder link-button" href="/store-finder/">
						Find a Store
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SpecialProductMessageBox",
	computed: {
		isInStore() {
			return this.$store.getters.isInStore;
		},
		isComing() {
			return this.$store.getters.isComing;
		},
		// Styles
		buttonColor() {
			return this.isComing ? 'grey-blue' : 'grey';
		},
		buttonText() {
			if (this.isInStore) {
				return 'Purchase In Stores Only';
			} else if (this.isComing) {
				//return 'Black Friday Starts 7am ET/6am CT!'; // TEMPORARY!!!
				return 'Coming Soon';
			}
			return '';
		},
		showSpecialStockMessage() {
			return this.isComing || this.isInStore;
		},
		message() {
			if (this.isInStore) {
				return 'Only carried in stores. Visit store for availability and to purchase.';
			} else {
				// DISABLED => return 'We’re getting this item ready for the big event. Please check back here when the sale starts!';
				return 'We’re getting this item ready, and it should be available soon. Please check back here to get the latest details!';
			}
		},
	},
};
</script>

<style lang="less" scoped>
	@import '../../../less/_mixins.less';

	.wrapper {
		max-width: 510px;
		width: 100%;
		font-size: 16px;
	}

	.main-button {
		padding: 15px;
	}

	.disabled {
		cursor: default;
	}

	.secondary-text {
		text-align: center;
		font-size: 17px;
		margin: 0 auto;
		padding: 10px 20px 15px 20px;
		line-height: 1.25em;
	}

	.content {
		background-color: #EDEDED;
	}

	.grey-darkgrey {
		color: #4A4A4A;
		.link-to-store-finder {
			color: #014A77;
		}
	}

	.red-grey {
		color: #666666;
		.secondary-text {
			color: #666666;
			.phone-link{
				color: #B12F31;
				text-decoration: none;
			}
		}
	}

	.wrapper-with-border {
		border-bottom: 1px solid #CCCCCC;
		border-top: 1px solid #CCCCCC;
		margin-bottom: 10px;
	}

	@media screen and (max-width: @mobile) {
		.wrapper {
			max-width: 100%;
		}

		.secondary-text {
			padding: 0 10px 10px;
			font-size: 13px;
		}

		.main-button {
			padding: 10px;
		}
	}
</style>